// extracted by mini-css-extract-plugin
export default {"followee_display_name":"social-follow-FollowAction__followee_display_name--2F3bI","verified":"social-follow-FollowAction__verified--3iHDV"};